import { OVERLAY_SHOWN } from "@/store/mutation-types";

const state = {
  overlay: false
};

const getters = {
  showOverlay: state => state.overlay
};

const mutations = {
  OVERLAY_SHOWN(state, show) {
    state.overlay = show;
  }
};

/**
 * Laboratory context actions
 * @type {{LAB_CONTEXT_POPULATE: function({commit: *})}}
 */
const actions = {
  OVERLAY_SHOW: ({ commit }) => {
    return new Promise(resolve => {
      commit(OVERLAY_SHOWN, true);
      resolve(true);
    });
  },
  OVERLAY_HIDE: ({ commit }) => {
    return new Promise(resolve => {
      commit(OVERLAY_SHOWN, false);
      resolve(false);
    });
  }
};

export default {
  getters,
  mutations,
  actions,
  state
};
